import React, { useEffect } from 'react';
import { Input, Form, FormInstance } from 'antd';
import FormDrawer from '../common/formdrawer';
import PageVersionStatus from './pageversionstatus';
import CancelButton from '../common/cancelbutton';
import FormButton from '../common/formbutton';
import { SaveOutlined } from '@ant-design/icons';

interface EditPageVersionFormProps {
  open: boolean;
  onClose: () => void;
  onUpdate: (values: { name: string }) => void;
  pageVersionName?: string;
}

const EditPageVersionForm: React.FC<EditPageVersionFormProps> = ({
  open,
  onClose,
  onUpdate,
  pageVersionName
}) => {
  const [form] = Form.useForm();
  const initialStatus = "finalized";

  useEffect(() => {
    if (open && pageVersionName) {
      form.setFieldsValue({ name: pageVersionName });
    }
  }, [open, pageVersionName, form]);

  const handleUpdate = (values: { name: string }) => {
    onUpdate(values);
  };

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  const footer = (
    <div style={{ textAlign: 'right' }}>
      <CancelButton onClick={() => handleClose()} />
      <FormButton
        title="Update"
        icon={<SaveOutlined />}
        onClick={() => {
          form.validateFields()
            .then((values) => {
              form.resetFields();
              handleUpdate(values);
            })
            .catch(err => console.log(err));
        }}
      />
    </div>
  );

  return (
    <FormDrawer
      title="Edit PageVersion Properties"
      open={open}
      onClose={handleClose}
      onSave={() => { }}
      form={form}
      footer={footer}
    >
      <PageVersionStatus status={initialStatus} />
      <Form.Item
        name="name"
        label="Name"
        rules={[
          {
            required: true,
            message: 'Please enter a name for the new page version!',
          },
          {
            validator: (_, value) => {
              if (value && value.trim() === '') {
                return Promise.reject(new Error('Name cannot be empty spaces.'));
              }
              return Promise.resolve();
            },
          },
        ]}
      >
        <Input placeholder="Enter new pageversion name" />
      </Form.Item>
    </FormDrawer>
  );
};

export default EditPageVersionForm;
